import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { PackingType } from '../../../../app/models/PackingType';

type Props = {
    packingType: PackingType;
    setPackingType: (packingType: PackingType) => void;
    errorFields?: any;
};

const PackingTypeForm = ({ packingType, setPackingType, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPackingType({ ...packingType, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Nombre</label>
                    <input
                        name="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={packingType.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Imgrese nombre tipo de empaque"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('name')}</div>
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Categoria</label>
                    <input
                        name="category"
                        type="text"
                        className={`form-control ${fieldHasError('category')}`}
                        value={packingType.category}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('category')}
                        placeholder="Imgrese categoria para tipo de empaque"

                    />
                    <div className="invalid-feedback">{fieldErrorMessage('category')}</div>
                </div>
            </div>
        </>
    );
};

export default PackingTypeForm;
